import './card-team.scss';

export default () => {

};
